var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "container-m" },
    [
      _c("page-title", {
        staticClass: "page-title",
        attrs: { title: "Einstellungen" }
      }),
      _vm._v(" "),
      _c("v-divider", { attrs: { id: "end-divider" } }),
      _vm._v(" "),
      _c(
        "v-form",
        {
          ref: "form",
          attrs: { id: "settings-form" },
          model: {
            value: _vm.formValid,
            callback: function($$v) {
              _vm.formValid = $$v
            },
            expression: "formValid"
          }
        },
        [
          _c(
            "v-expansion-panel",
            { staticClass: "expansion-panel", attrs: { expand: "" } },
            _vm._l(_vm.dropdownTitles, function(item, i) {
              return _c(
                "v-expansion-panel-content",
                {
                  key: i,
                  attrs: { id: "expansion-panel" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "actions",
                        fn: function() {
                          return [
                            _c("v-icon", { staticClass: "icon-expand" }, [
                              _vm._v("$vuetify.icons.expand")
                            ])
                          ]
                        },
                        proxy: true
                      },
                      {
                        key: "header",
                        fn: function() {
                          return [_c("div", [_vm._v(_vm._s(item))])]
                        },
                        proxy: true
                      }
                    ],
                    null,
                    true
                  )
                },
                [
                  _vm._v(" "),
                  _vm._v(" "),
                  i === 0
                    ? _c("editor", {
                        attrs: { id: _vm.EditorType.TermsOfUse },
                        on: {
                          change: function($event) {
                            return _vm.updateEditor(
                              $event,
                              _vm.EditorType.TermsOfUse
                            )
                          }
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  i === 1
                    ? _c("editor", {
                        attrs: { id: _vm.EditorType.BlockedAccount },
                        on: {
                          change: function($event) {
                            return _vm.updateEditor(
                              $event,
                              _vm.EditorType.BlockedAccount
                            )
                          }
                        }
                      })
                    : i === 2
                    ? _c("v-text-field", {
                        attrs: {
                          rules: [
                            _vm.rules.sizeMin,
                            _vm.rules.sizeMax,
                            _vm.rules.required
                          ],
                          label: "Maximale Größe der Datei",
                          type: "number",
                          min: "1",
                          max: _vm.maxSizeFile,
                          suffix: "KB"
                        },
                        on: {
                          input: function($event) {
                            return _vm.checkForm()
                          }
                        },
                        model: {
                          value: _vm.settings.maxSizeAttachment,
                          callback: function($$v) {
                            _vm.$set(_vm.settings, "maxSizeAttachment", $$v)
                          },
                          expression: "settings.maxSizeAttachment"
                        }
                      })
                    : i === 3
                    ? _c(
                        "div",
                        [
                          _c("label", [
                            _c("b", [
                              _vm._v(
                                "Zeitpunkt, ab dem der Hinweis angezeigt wird"
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("v-datetime-picker", {
                            staticClass: "custom-label-color",
                            attrs: {
                              "text-field-props": _vm.textFieldPropsFrom,
                              "date-picker-props": _vm.dateProps,
                              "time-picker-props": _vm.timeProps,
                              "time-format": "HH:mm",
                              "date-format": "dd.MM.yyyy"
                            },
                            on: {
                              input: function($event) {
                                return _vm.checkForm()
                              }
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "actions",
                                  fn: function(ref) {
                                    var parent = ref.parent
                                    return [
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: { color: "info darken-1" },
                                          on: {
                                            click: function($event) {
                                              return _vm.actualDateFrom(parent)
                                            }
                                          }
                                        },
                                        [_vm._v("Aktuelles Datum")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: { color: "success darken-1" },
                                          on: { click: parent.okHandler }
                                        },
                                        [_vm._v("OK")]
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              true
                            ),
                            model: {
                              value:
                                _vm.settings.specialSituationMessage.dateFrom,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.settings.specialSituationMessage,
                                  "dateFrom",
                                  $$v
                                )
                              },
                              expression:
                                "settings.specialSituationMessage.dateFrom"
                            }
                          }),
                          _vm._v(" "),
                          _c("label", [
                            _c("b", [
                              _vm._v(
                                "Zeitpunkt, bis zu dem der Hinweis angezeigt wird"
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("v-datetime-picker", {
                            staticClass: "custom-label-color",
                            attrs: {
                              "text-field-props": _vm.textFieldPropsTo,
                              "date-picker-props": _vm.dateProps,
                              "time-picker-props": _vm.timeProps,
                              "time-format": "HH:mm",
                              "date-format": "dd.MM.yyyy"
                            },
                            on: {
                              input: function($event) {
                                return _vm.checkForm()
                              }
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "actions",
                                  fn: function(ref) {
                                    var parent = ref.parent
                                    return [
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: { color: "info darken-1" },
                                          on: {
                                            click: function($event) {
                                              return _vm.actualDateTo(parent)
                                            }
                                          }
                                        },
                                        [_vm._v("Aktuelles Datum")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: { color: "success darken-1" },
                                          on: { click: parent.okHandler }
                                        },
                                        [_vm._v("OK")]
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              true
                            ),
                            model: {
                              value:
                                _vm.settings.specialSituationMessage.dateTo,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.settings.specialSituationMessage,
                                  "dateTo",
                                  $$v
                                )
                              },
                              expression:
                                "settings.specialSituationMessage.dateTo"
                            }
                          }),
                          _vm._v(" "),
                          _c("label", [
                            _c("b", [
                              _vm._v(
                                "Hinweis an die Kunden über die besondere Situation"
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("editor", {
                            attrs: { id: _vm.EditorType.SpecialMessage },
                            on: {
                              change: function($event) {
                                return _vm.updateEditor(
                                  $event,
                                  _vm.EditorType.SpecialMessage
                                )
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            }),
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }